import { Button, type ButtonProps } from '@chakra-ui/react'
import { cx } from '@chakra-ui/utils'
import { ContentfulLivePreview } from '@contentful/live-preview'
import NextLink from 'next/link'
import { type ReactNode, useState } from 'react'
import { PopoutIcon } from '~/Assets/icons'
import useNavigationActions from '~/hooks/useNavigationActions'
import { type IButton } from '~/types/generated/contentful'

import { type IReducedButton } from '../../../types/reducedTypes'
import LightboxWithHtml from '../FormLoader/FormLoader'

export default function ContentfulButton({
  buttonData,
  children,
  ...buttonProps
}: {
  buttonData: IButton | IReducedButton
  children?: ReactNode
} & ButtonProps) {
  const action = useNavigationActions(buttonData.fields)
  const [openLB, setOpenLB] = useState(false)
  const popupOverlay =
    buttonData?.fields && 'popupOverlay' in buttonData.fields
      ? (buttonData.fields as any).popupOverlay
      : undefined
  return (
    <>
      {openLB && (
        <LightboxWithHtml
          formname={popupOverlay}
          handleClose={() => setOpenLB(!openLB)}
        />
      )}
      <Button
        className={cx('contentful-button', buttonData.fields.htmlClasses)}
        as={NextLink}
        {...action}
        variant={buttonData.fields?.variant ?? 'primary'}
        {...buttonProps}
        {...ContentfulLivePreview.getProps({
          entryId: buttonData.sys.id,
          fieldId: 'text',
        })}
        aria-label={buttonData.fields?.ariaLabel}
        title={buttonData.fields?.titleAttribute}
        onClick={e => {
          if (popupOverlay) {
            e.preventDefault()
            setOpenLB(!openLB)
          }
        }}
      >
        {children ?? buttonData.fields.text}
        {action?.target === '_blank' && (
          <PopoutIcon aria-label="opens in new tab" />
        )}
      </Button>
    </>
  )
}
